import { render, staticRenderFns } from "./NeedDetailsNei.vue?vue&type=template&id=a7f83bb8&scoped=true"
import script from "./NeedDetailsNei.vue?vue&type=script&lang=js"
export * from "./NeedDetailsNei.vue?vue&type=script&lang=js"
import style0 from "./NeedDetailsNei.vue?vue&type=style&index=0&id=a7f83bb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f83bb8",
  null
  
)

export default component.exports